<template>
    <svg width="35" height="35" version="1.1" viewBox="0 0 63.584 60.055" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(-44.904 -28.945)">
            <path d="m102.05 59.631a27.781 27.781 0 0 1-27.671 27.781 27.781 27.781 0 0 1-27.891-27.561 27.781 27.781 0 0 1 27.45-28" fill="none" stroke="currentColor" stroke-dasharray="19.05, 6.35" stroke-dashoffset="19.368" stroke-linecap="round" stroke-opacity=".94118" stroke-width="3.175" style="paint-order:fill markers stroke"/>
            <text x="75.034111" y="69.026497" fill="currentColor" font-family="sans-serif" font-size="19.756px" letter-spacing="0px" stroke-width=".26458" text-align="center" text-anchor="middle" word-spacing="0px" style="line-height:1.25" xml:space="preserve"><tspan x="75.034111" y="69.026497" stroke-width=".26458"><tspan x="75.034111" y="69.026497" font-size="22.578px" stroke-width=".26458" text-align="center" text-anchor="middle">45°</tspan></tspan></text>
            <path d="m93.835 52.78 7.7588 9.1024 6.8934-9.2465" stroke-width="0" style="paint-order:fill markers stroke" fill="currentColor" stroke="currentColor"/>
            <path transform="rotate(268.32)" d="m-34.323 75.807a24.077 24.077 0 0 1-21.412 23.929" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="6.2581" style="paint-order:fill markers stroke"/>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "SVGPhotoRotateRight45"
    }
</script>

<style scoped>

</style>
